import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../config/apiConfig";
import useApi from "../hooks/useApi";
import {
  getDataFromLocalStorage,
  setDataOnLocalStorage,
} from "../util/localStorage";
import AI_PDF_CONST from "../util/PdfAiConst";
import uploadIcon from "../images/uploadIconWhite.svg";
import Loader from "./Loader";
import ErrorPopUpComponent from "./ErrorPopUpComponent";
import DocumentCard from "./DocumentCard";
import ConfirmDeletePopUp from "./DeletePopUp"; // Import the new PopUp component

const ListComponent = () => {
  const [docList, setDocList] = useState([]);
  const { callApi, loading, error } = useApi();
  const navigate = useNavigate();
  const [errorPopupState, setErrorPopupState] = useState({
    isShow: false,
    message: "",
  });
  const [redirect, setRedirect] = useState("/home");
  const [deletePopupState, setDeletePopupState] = useState({
    isShow: false,
    message: "",
  });
  const [deleteDoc, setDeleteDoc] = useState(null);

  useEffect(() => {
    handleGetAllList();
  }, []);

  const handleGetAllList = async () => {
    setRedirect("/home");
    setErrorPopupState({ isShow: false, message: "" }); // Reset error popup state
    setDeletePopupState({ isShow: false, message: "" }); // Reset delete popup state
    try {
      const token = getDataFromLocalStorage("token");

      if (!token) {
        setErrorPopupState({
          isShow: true,
          message: "Token not found. Please log in first.",
        });
        return;
      }
      const data = await callApi(
        `${baseUrl + AI_PDF_CONST.API_ENDPOINT.DOCS}`,
        "GET",
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );
      setDocList(data.data);
      setDataOnLocalStorage("documentList", data.data);
    } catch (err) {
      setErrorPopupState({
        isShow: true,
        message: "Failed to fetch documents",
      });
    }
  };

  const goToPdfView = (item) => {
    setDataOnLocalStorage("currentDoc", item);
    navigate(`/documents/${item.id}`);
  };

  const deleteDocument = async () => {
    setRedirect("");
    if (!deleteDoc) return;
    setErrorPopupState({ isShow: false, message: "" });

    try {
      const token = getDataFromLocalStorage("token");

      if (!token) {
        setErrorPopupState({
          isShow: true,
          message: "Token missing. Please log in.",
        });
        return;
      }
      await callApi(
        `${baseUrl + AI_PDF_CONST.API_ENDPOINT.DOCS}${deleteDoc.id}`,
        "DELETE",
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );
      handleGetAllList(); // Refresh document list
      setDeletePopupState({
        isShow: true,
        message: "Document deleted successfully.",
      });
      setDeleteDoc(null); // Reset deleteDoc state
    } catch (err) {
      const errorMessage =
        err?.response?.data?.msg ||
        err.message ||
        "Unable to delete the document.";
      setErrorPopupState({ isShow: true, message: errorMessage });
      setDeleteDoc(null); // Reset deleteDoc state in case of error
    }
  };

  const handleDeleteItem = (item) => {
    setErrorPopupState({ isShow: false, message: "" });
    setDeleteDoc(item);
    setDeletePopupState({
      isShow: true,
      message: "Are you sure you want to delete this document?",
    });
  };

  return (
    <div className="p-32 dashboardMain minHieght bg-[#141a2a]">
      <h1 className="text-[22px] text-white font-medium mb-8 border-b border[#fefefe] pb-2 relative">
        Document List
        <Link to="/documents">
          <span className="absolute top-2 right-0 flex flex-row sm:text-[18px] text-[14px] items-center justify-center text-[#f1f1f1] hover:text-[#fff]">
            <img
              src={uploadIcon}
              alt="upload"
              className="sm:h-[23px] h-[20px] mr-1"
            />
            Upload Document
          </span>
        </Link>
      </h1>
      <div className="listTable w-full flex flex-row flex-wrap mb-[50px]">
        {loading ? (
          <div className="loader">
            <Loader />
          </div>
        ) : Array.isArray(docList) && docList.length > 0 ? (
          docList.map((item) => (
            <DocumentCard
              key={item.id}
              item={item}
              onDelete={handleDeleteItem}
              onView={goToPdfView}
            />
          ))
        ) : (
          <div className="no-documents text-center w-full mt-16 text-[24px] text-white">
            <p>No documents found. Please upload a new document.</p>
            {/* <Link
              to="/documents"
              className="text-blue-300 underline hover:text-white"
            >
              Upload Document
            </Link> */}
          </div>
        )}
      </div>

      {/* Error Popup */}
      <ErrorPopUpComponent
        isErrorShow={errorPopupState.isShow}
        errorMessage={errorPopupState.message}
        redirect={redirect}
      />

      {/* Delete Confirmation Popup */}
      <ConfirmDeletePopUp
        isPopUp={deletePopupState.isShow && deleteDoc}
        setIsPopup={(status) => {
          setDeletePopupState({ ...deletePopupState, isShow: status });
        }}
        onConfirm={deleteDocument}
      />
    </div>
  );
};

export default ListComponent;
